/*
 * @Descripttion: 资讯管理
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'information-mgmt';

export { name, route };
